import { useParams } from 'react-router-dom';

import { TopStatusBar } from '../../components/domain/TopStatusBar';
import { useAccounts } from '../accounts/queries';
import { useMe } from '../auth/queries';
import { useReviewContext } from '../reviews/useReviewContext';
import { useLatestSnapshot } from '../snapshots/queries';

import { DeepReviewCard } from './DeepReviewCard';
import { QuickReviewCard } from './QuickReviewCard';

export function ReviewPage() {
  const params = useParams();
  const tradeId = params.tradeId ?? null;
  const me = useMe();
  const accounts = useAccounts();
  const activeAccountId = accounts.data?.[0]?.id ?? null;
  const snapshot = useLatestSnapshot(activeAccountId);
  const context = useReviewContext(tradeId);

  if (me.isLoading || context.isLoading) {
    return <main className="p-6 text-text-muted">Loading review...</main>;
  }

  if (me.isError || !me.data || context.isError || !context.data || !tradeId) {
    return <main className="p-6 text-danger">Could not load this review.</main>;
  }

  return (
    <main className="min-h-screen bg-bg text-text">
      <TopStatusBar currency={me.data.baseCurrency} snapshot={snapshot.data} />
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8">
        {context.data.reviewMode === 'quick' ? (
          <QuickReviewCard context={context.data} tradeId={tradeId} />
        ) : (
          <DeepReviewCard context={context.data} tradeId={tradeId} />
        )}
      </div>
    </main>
  );
}
